import React from 'react';
import { Typography, Box, Container, Grid, Button } from '@mui/material';
import { IMAGES, yellowGlowSx } from '../theme';
import { useQuote } from './QuoteDialog';
const projects = [{
  image: IMAGES.hero,
  label: 'Modern Flat-Roof Cabana',
  location: 'Brentwood, CA'
}, {
  image: IMAGES.waterfront,
  label: 'Waterfront Patio Cover',
  location: 'Discovery Bay, CA'
}, {
  image: IMAGES.polycarbonate,
  label: 'Polycarbonate Patio Cover',
  location: 'Brentwood, CA'
}, {
  image: IMAGES.patioFan,
  label: 'Covered Patio with Fans',
  location: 'Brentwood, CA'
}, {
  image: IMAGES.solid,
  label: 'Solid Roof Pergola',
  location: 'Brentwood, CA'
}, {
  image: IMAGES.hillsideGarden,
  label: 'Hillside Garden Cover',
  location: 'Antioch, CA'
}, {
  image: IMAGES.attachedSolid,
  label: 'Attached Solid Patio Cover',
  location: 'Brentwood, CA'
}, {
  image: IMAGES.detailGutter,
  label: 'Seamless Gutter Detailing',
  location: 'Brentwood, CA'
}, {
  image: IMAGES.loungeGarden,
  label: 'Garden Lounge Cover',
  location: 'Brentwood, CA'
}, {
  image: IMAGES.wraparound,
  label: 'Full-Width Patio Cover',
  location: 'Brentwood, CA'
}, {
  image: IMAGES.whiteCorner,
  label: 'Modern Corner Cabana',
  location: 'Brentwood, CA'
}, {
  image: IMAGES.shadeScreen,
  label: 'Cover with Shade Screens',
  location: 'Brentwood, CA'
}, {
  image: IMAGES.deckCover,
  label: 'Elevated Deck Cover',
  location: 'Brentwood, CA'
}, {
  image: IMAGES.poolside,
  label: 'Poolside Patio Cover',
  location: 'Brentwood, CA'
}, {
  image: IMAGES.whiteFlat,
  label: 'Clean White Flat Cover',
  location: 'Brentwood, CA'
}, {
  image: IMAGES.poolLattice,
  label: 'Poolside Lattice Pergola',
  location: 'Brentwood, CA'
}, {
  image: IMAGES.wraparoundGray,
  label: 'Wraparound Gray Cover',
  location: 'Brentwood, CA'
}, {
  image: IMAGES.graySolid,
  label: 'Gray Solid Patio Cover',
  location: 'Brentwood, CA'
}, {
  image: IMAGES.sunroom,
  label: 'Enclosed Sunroom',
  location: 'Brentwood, CA'
}, {
  image: IMAGES.freestanding,
  label: 'Freestanding Patio Cover',
  location: 'Brentwood, CA'
}, {
  image: IMAGES.recessedLighting,
  label: 'Cover with Recessed Lighting',
  location: 'Brentwood, CA'
}, {
  image: IMAGES.deckBalcony,
  label: 'Covered Deck Balcony',
  location: 'Brentwood, CA'
}, {
  image: IMAGES.stringLights,
  label: 'Lattice with String Lights',
  location: 'Brentwood, CA'
}, {
  image: IMAGES.stoneLattice,
  label: 'Stone Column Lattice Pergola',
  location: 'Brentwood, CA'
}, {
  image: IMAGES.waterfrontDeck,
  label: 'Waterfront Covered Deck',
  location: 'Discovery Bay, CA'
}, {
  image: IMAGES.hillsideView,
  label: 'Hillside View Cover',
  location: 'Brentwood, CA'
}, {
  image: IMAGES.gardenSolid,
  label: 'Garden Solid Patio Cover',
  location: 'Brentwood, CA'
}, {
  image: IMAGES.frontLattice,
  label: 'Front Entry Lattice Cover',
  location: 'Brentwood, CA'
}];
export function Gallery() {
  const {
    openQuote
  } = useQuote();
  return <Box component="section" id="gallery" sx={{
    py: {
      xs: 8,
      md: 12
    },
    bgcolor: 'background.default'
  }} data-id="element-32">
      <Container maxWidth="lg" data-id="element-33">
        <Box sx={{
        textAlign: 'center',
        mb: 8,
        maxWidth: '760px',
        mx: 'auto'
      }} data-id="element-34">
          <Typography variant="h6" color="secondary.main" fontWeight="bold" textTransform="uppercase" letterSpacing={1} gutterBottom sx={yellowGlowSx} data-id="element-35">
            Our Work
          </Typography>
          <Typography variant="h2" color="primary.main" sx={{
          mb: 3,
          fontSize: {
            xs: '2.5rem',
            md: '3.5rem'
          }
        }} data-id="element-36">
            Recently Completed Projects
          </Typography>
          <Typography variant="h6" color="text.secondary" fontWeight="400" data-id="element-37">
            Real patio covers built for real homeowners across the East Bay.
          </Typography>
        </Box>

        <Grid container spacing={3} data-id="element-38">
          {projects.map(project => <Grid item xs={12} sm={6} key={project.label} data-id="element-39">
              <Box sx={{
            position: 'relative',
            borderRadius: 2,
            overflow: 'hidden',
            height: {
              xs: 260,
              md: 340
            },
            cursor: 'pointer',
            '&:hover img': {
              transform: 'scale(1.05)'
            },
            '&:hover .overlay': {
              opacity: 1
            }
          }} data-id="element-40">
                <Box component="img" src={project.image} alt={project.label} sx={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              transition: 'transform 0.4s ease',
              display: 'block'
            }} data-id="element-41" />
                <Box className="overlay" sx={{
              position: 'absolute',
              inset: 0,
              background: 'linear-gradient(to top, rgba(4,78,92,0.88) 0%, rgba(4,78,92,0) 55%)',
              opacity: 0.9,
              transition: 'opacity 0.3s ease',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-end',
              p: 3
            }} data-id="element-42">
                  <Typography variant="h6" color="white" fontWeight="bold" data-id="element-43">
                    {project.label}
                  </Typography>
                  <Typography variant="body2" color="secondary.main" fontWeight="600" sx={yellowGlowSx} data-id="element-44">
                    {project.location}
                  </Typography>
                </Box>
              </Box>
            </Grid>)}
        </Grid>

        <Box sx={{
        textAlign: 'center',
        mt: 6
      }} data-id="element-45">
          <Button variant="contained" color="secondary" size="large" onClick={openQuote} sx={{
          fontSize: '1.1rem',
          py: 1.5,
          px: 4
        }} data-id="element-46">
            Start Your Project
          </Button>
        </Box>
      </Container>
    </Box>;
}